import Breadcrumb from "../../components/Breadcrumb";
import Sidebar from "../../components/Blog/Sidebar";
import { Link } from "react-router-dom";
import RightArrow from "../../components/SVG";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useState } from "react";
import Cookies from "js-cookie";

const NewsDetailsMain = ({
  news,
  isLoading,
  isError,
  relatedNews,
  relatedLoading,
  relatedError,
  formattedTitle,
}) => {
  const [activeTab, setActiveTab] = useState("public");

  const [auth, setAuth] = useState(() => {
    const token = Cookies.get("token");
    const role = Cookies.get("role");
    const email = Cookies.get("email");
    return { token, role, email };
  });
  const isAuthenticated = !!(auth?.token && auth?.role && auth?.email);

  const sliderOption = {
    speed: 1000,
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      prevEl: ".postbox-arrow-prev",
      nextEl: ".postbox-arrow-next",
    },
  };

  // Filter related news based on active tab
  const getFilteredRelatedNews = () => {
    if (!relatedNews) return [];

    if (!isAuthenticated) {
      return relatedNews.filter((item) => item.visibility === "public");
    }

    switch (activeTab) {
      case "public":
        return relatedNews.filter((item) => item.visibility === "public");
      case "private":
        return relatedNews.filter((item) => item.visibility === "private");
      case "all":
      default:
        return relatedNews;
    }
  };

  const filteredRelatedNews = getFilteredRelatedNews();

  if (isLoading) return <p className="text-center py-10">Loading...</p>;
  if (isError || !news)
    return <p className="text-center py-10">Error loading news details.</p>;

  const { title, description, date, imageUrl } = news;

  return (
    <main>
      <Breadcrumb
        title={formattedTitle}
        subtitle={{ label: "News", link: "/news" }}
      />

      <div className="postbox__area fix pt-50 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 mb-50 order-3 order-md-0">
              <div className="it-blog-button text-start text-md-end">
                <Link className="ed-btn-theme" to="/news">
                  Back to News Page
                  <i>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>

            <div className="col-xxl-8 col-xl-8 col-lg-8">
              <div className="postbox__details-wrapper">
                <article>
                  <div className="postbox__details-title-box pb-0">
                    <div className="postbox__meta">
                      <span>
                        <i className="fa-solid fa-calendar-days"></i>{" "}
                        {new Date(date).toLocaleDateString("en-IN", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </span>
                    </div>
                    <h4 className="postbox__title mb-20 pr-30">{title}</h4>
                    <div
                      className="event-description-content mb-0 pb-10"
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    />
                  </div>
                </article>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-4 col-lg-4">
              <div className="postbox__thumb-box">
                <div className="it-postbox__wrapper p-relative mb-30">
                  <div className="swiper-container postbox__thumb-slider-active">
                    <Swiper
                      modules={[Autoplay, Navigation]}
                      {...sliderOption}
                      className="swiper-wrapper"
                    >
                      {imageUrl?.map((url, idx) => (
                        <SwiperSlide key={idx} className="swiper-slide">
                          <div className="postbox__main-thumb h-64 w-full overflow-hidden">
                            <img
                              src={url}
                              alt={`news-${idx}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <div className="postbox__slider-arrow-wrap">
                    <button className="postbox-arrow-prev">
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <button className="postbox-arrow-next">
                      <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <Sidebar
                relatedNews={filteredRelatedNews}
                isAuthenticated={isAuthenticated}
                showFilters={false}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NewsDetailsMain;
